import type { ContactUsConfig } from './types'
import { commonTexts } from './common'

/**
 * AureNovel 品牌 Contact Us 页面配置
 */
export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: '#ffffff',
    bgTertiary: '#F3F5FA',
    textPrimary: '#32353A',
    textTertiary: '#9296A0',
    textPlaceholder: '#c8c9cc',
    accentRed: '#FC5549',
    primaryColor: '#FFB300',
    whiteColor: '#FFFFFF',
  },
}
